import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-error';

/**
 * Estado remoto vive só aqui: nenhum store global espelhando dados do
 * servidor.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          // Repetir 4xx é insistir num erro determinístico — só piora a
          // percepção de lentidão. 5xx e falha de rede valem uma nova tentativa.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
